import { getAccessToken, getRefreshDelayMs } from 'auth/tokenStore';
import { refreshAccessToken } from 'auth/sessionRefresh';

let refreshTimerId = null;
let visibilityListener = null;

function clearRefreshTimer() {
  if (refreshTimerId != null) {
    window.clearTimeout(refreshTimerId);
    refreshTimerId = null;
  }
}

function scheduleRefresh(refreshFn) {
  clearRefreshTimer();
  if (!getAccessToken()) {
    return;
  }

  const delay = getRefreshDelayMs();
  if (delay == null) {
    return;
  }

  refreshTimerId = window.setTimeout(async () => {
    try {
      await refreshFn();
    } catch {
      // refreshAccessToken handles auth expiry; transient errors retry on the next tick.
    }
    if (getAccessToken()) {
      scheduleRefresh(refreshFn);
    }
  }, delay);
}

function handleVisibilityChange(refreshFn) {
  if (document.visibilityState !== 'visible' || !getAccessToken()) {
    return;
  }
  refreshFn({ force: true }).catch(() => {
    // Errors are handled inside refreshAccessToken.
  });
}

export function startSessionKeepAlive(refreshFn = refreshAccessToken) {
  stopSessionKeepAlive();
  scheduleRefresh(refreshFn);
  visibilityListener = () => handleVisibilityChange(refreshFn);
  document.addEventListener('visibilitychange', visibilityListener);
  return () => stopSessionKeepAlive();
}

export function stopSessionKeepAlive() {
  clearRefreshTimer();
  if (visibilityListener) {
    document.removeEventListener('visibilitychange', visibilityListener);
    visibilityListener = null;
  }
}
